import PropTypes from "prop-types";
import React from 'react';
import {Link} from "react-router-dom";

const WorkItemTwo = ({ data }) => {
    return (
        <div className="work"  style={{backgroundColor:'#030E22'}}>
            <div className="thumbnail">
                <Link className="image" to={process.env.PUBLIC_URL + `/ipDetail/${data.id}`}><video 
                 autoPlay
                 
                 muted
                 loop
                 playsInline={true}
               style={{maxHeight:'220px',width:'100%', objectFit:'contain'}}>  <source src={data.video}></source></video></Link>
                {/* <Link className="image" to={process.env.PUBLIC_URL + `/ipDetail/${data.id}`}><video autoPlay={true} loop={true}  style={{maxHeight:'220px'}}><source src={process.env.PUBLIC_URL + data.image} type="video/mp4" />  </video></Link> */}

            </div>
            <div className="info" style={{padding:'10px', paddingBottom:'20px', borderColor:'#030E22',textAlign:'left', backgroundColor:'#030E22'}}>
                {/* <h3 className="title"><Link to={process.env.PUBLIC_URL + `/work-details/${data.id}`}>{data.title}</Link></h3> */}
                {/* <h3 className="title">{data.title}</h3> */}
                <h4 style={{color:"#2ea3f2"}}>{data.Ctitle}</h4>
                <p className="desc"  id="HomeCard_hover" ><Link to={process.env.PUBLIC_URL + `/ipDetail/${data.id}`}>{data.Cbody}</Link></p>
                {/* <Link to={process.env.PUBLIC_URL + `/ipDetail/${data.id}`} style={{color:'#1400c6'}}>Learn More</Link> */}
            </div>
        </div>
    )
}

WorkItemTwo.propTypes = {
    data: PropTypes.object
};

export default WorkItemTwo;
